import React, { useEffect, useState } from "react";
import axios from "axios";
import "./DetailKomoditas.scss";
import { Link, useParams, useHistory } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { config } from "../../config";
import { Spin } from "antd";
import LoadingOverlay from "../../component/LoadingOverlay";

const DetailKomoditas = () => {
  const { id } = useParams(); // Extract ID from route
  const [komoditas, setKomoditas] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const history = useHistory();

  const handleClick = (e) => {
    e.preventDefault();
    history.push("/");

    setTimeout(() => {
      const element = document.getElementById("komoditas");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  useEffect(() => {
    const fetchKomoditas = async () => {
      try {
        const response = await axios.get(
          `${config.BASE_URL}komoditas/webFindOne/${id}`
        );
        setKomoditas(response.data.data.komoditas); // akses nested data.komoditas
        setLoading(false);
      } catch (err) {
        console.error("Error fetching komoditas:", err);
        setError("Gagal memuat data komoditas.");
        setLoading(false);
      }
    };

    fetchKomoditas();
  }, [id]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <LoadingOverlay />
        <p style={{ color: "#F1582E", marginTop: "10px", fontWeight: "bold" }}>
          Harap Tunggu Sesaat...
        </p>
      </div>
    );
  }

  if (error) {
    return <p>{error}</p>;
  }

  return (
    <section id="DetailKomoditas">
      <div className="navbar">
        <a href="#" onClick={handleClick} className="link-back">
          <FeatherIcon icon="arrow-left" />
          Kembali
        </a>
      </div>
      <div className="container">
        <div className="news-content">
          <h2>{komoditas.nama}</h2>
          <p className="news-date">
            {new Date(komoditas.tanggalRelease).toLocaleString("id-ID")}
          </p>
          <img
            src={
              komoditas.foto
                ? `${
                    config.BASE_URL
                  }getReferenceFile?pathFile=${encodeURIComponent(
                    komoditas.foto
                  )}`
                : "/assets/images/default.png"
            }
            alt={komoditas.nama}
          />
          <p>{komoditas.keterangan}</p>
        </div>
      </div>
    </section>
  );
};

export default DetailKomoditas;
